"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.operation_pyXlsx2Csv2 = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
const commonOperationNode_1 = require("../../commonOperationNode");
const utils_1 = require("../../utils");
const types_1 = require("./types");
const friendlyName = 'Py-Xlsx';
const commonProps = (0, commonOperationNode_1.commonZodOperationNodeUtils)(types_1.nodeType, types_1.UiConfigSchema, friendlyName);
// create a new UI node of this type.
const createNewNode = ({ id, nodeToCopy }) => {
    const nodeData = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            operation: 'pyXlsx2Csv2',
            mode: 'convertRange',
            sheetName: 'Sheet1',
            headerRange: 'A1:Z1',
        },
    };
    if (nodeToCopy) {
        (0, common_1.finleyAssert)(commonProps.isNode(nodeToCopy), `node must be a ${types_1.nodeType} node`);
        nodeData.configuration = _.cloneDeep(nodeToCopy.configuration);
    }
    return nodeData;
};
/*
 * validate the configuration for the node. This checks shape as well
 * logical correctness.
 * This function should validate the config wrt rest of the graph as well.
 * if there is an error it should return an array of error messages.
 * if there are no errors it should return an empty array.
 */
const hasValidConfig = ({ graph, node, getUINode, }) => {
    (0, common_1.finleyAssert)(commonProps.isNode(node), `node must be a ${types_1.nodeType} node`);
    const allowedInputNodes = [
        'file_rawLoanTape',
        'file_rawCashBalanceFeed',
        'file_rawRepaymentTape',
        'file_rawSupplementalTape',
        'file_rawReceivableDocumentation',
    ];
    const errors = (0, utils_1.checkEdges)({
        node,
        graph,
        isAllowedInputNode: (uiNode) => allowedInputNodes.includes(uiNode.nodeType),
        getUINode,
        minInputs: 1,
        maxInputs: 1,
        minOutputs: 1,
        maxOutputs: 1,
    });
    const extractionParamsResult = (0, tape_sanitizer_1.parsePyExtractionParams)(node.configuration);
    if (!extractionParamsResult.isValid) {
        extractionParamsResult.errors.forEach((err) => {
            errors.push(err);
        });
    }
    return errors;
};
/**
 * Represents an opearation node
 */
exports.operation_pyXlsx2Csv2 = {
    ...commonProps,
    nodeTypeText: friendlyName,
    nodeType: types_1.nodeType,
    operationType: 'tapebuilder_preSanitize',
    createNewNode,
    hasValidConfig,
};
//# sourceMappingURL=uinode.js.map